// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.analysis-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 1200px;
  max-height: calc(80vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.analysis-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.analysis-modal-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.analysis-modal-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
}

.analysis-modal-close:hover {
  color: #333;
}

.analysis-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysis-conn-select {
  max-width: 300px;
}

.analysis-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.analysis-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background: white;
  cursor: pointer;
}

.analysis-select:hover {
  border-color: #3b82f6;
}

.analysis-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.analysis-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.analysis-loading {
  font-size: 16px;
  color: #6b7280;
}

.analysis-coming-soon {
  text-align: center;
  padding: 40px 20px;
}

.analysis-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.analysis-coming-soon h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #1f2937;
}

.analysis-coming-soon p {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #6b7280;
}

.analysis-info {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
  max-width: 400px;
  margin: 0 auto;
}

.analysis-info h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #1f2937;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
}

.info-item span:first-child {
  color: #6b7280;
  font-weight: 500;
}

.info-item span:last-child {
  color: #374151;
}

.status-active {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-inactive {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.analysis-modal-footer {
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  justify-content: flex-end;
}

.analysis-btn {
  /* 아이콘+텍스트 정렬 — 예전에는 텍스트 앞에 공백을 넣어 띄웠는데, 그러면 아이콘이
     baseline 에 걸려 살짝 내려앉는다. flex 로 세로 중앙을 맞추고 간격은 gap 이 준다
     (.dbmsperf-btn 과 같은 규칙 — 두 모달이 한 창의 탭으로 합쳐졌다). */
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease;

  /* variant(-primary/-secondary) 없이 쓰는 버튼(결과 보기, 취소)이 브라우저 기본
     버튼 색(밝은 회색 ButtonFace + 검은 글자)으로 떨어지는 것을 막는다.
     다크모드에서 이 기본색이 흰 판처럼 튀어 보였다. */
  background: #f3f4f6;
  color: #374151;
  border-color: #d1d5db;
}

.analysis-btn:hover {
  background: #e5e7eb;
}

/* 다크 기본값 — 아래의 -secondary / -primary 다크 규칙이 뒤에 오므로 그쪽이 우선한다 */
[data-theme="dark"] .analysis-btn {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border-color: var(--color-border);
}

[data-theme="dark"] .analysis-btn:hover {
  background: var(--color-hover);
}

@media (prefers-reduced-motion: reduce) {
  .analysis-btn { transition: none; }
}

.analysis-btn-secondary {
  background: #e5e7eb;
  color: #374151;
  border-color: #d1d5db;
}

.analysis-btn-secondary:hover {
  background: #d1d5db;
}

/* Dark mode */
[data-theme="dark"] .analysis-modal {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .analysis-modal-header {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .analysis-modal-header h2 {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-modal-close {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-modal-close:hover {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-label {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .analysis-select {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .analysis-select:hover {
  border-color: var(--color-hover-border, #5a5a5a);
}

[data-theme="dark"] .analysis-select:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .analysis-coming-soon h3 {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-coming-soon p {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-info {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}

[data-theme="dark"] .analysis-info h4 {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .info-item span:first-child {
  color: var(--color-text-muted);
}

[data-theme="dark"] .info-item span:last-child {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-modal-footer {
  border-top-color: var(--color-border);
}

[data-theme="dark"] .analysis-btn-secondary {
  background: var(--color-btn-bg);
  color: var(--color-text);
  border: 1px solid var(--color-btn-border);
}

[data-theme="dark"] .analysis-btn-secondary:hover {
  background: var(--color-hover);
}

/* ===================================================================
   오라클 SQL 성능 분석 — 탭 UI (실행 중인 쿼리 / 수집 결과)
   =================================================================== */

.analysis-modal-wide {
  max-width: 1400px;
  height: calc(85vh / var(--app-zoom, 1));
}

.analysis-modal-body-flex {
  padding: 16px 20px;
  gap: 12px;
}

@keyframes analysis-fade-swap {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

.analysis-fade-swap {
  animation: analysis-fade-swap 160ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-fade-swap { animation: none; }
}

.analysis-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.analysis-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border: none;
  background: none;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: color 150ms ease, border-color 150ms ease;
}

.analysis-tab:hover {
  color: #374151;
}

.analysis-tab.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-tab { transition: none; }
}

.analysis-tabs-spacer {
  flex: 1 1;
}

.analysis-select-inline {
  width: auto;
  min-width: 160px;
  padding: 5px 10px;
  font-size: 12px;
}

.analysis-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.analysis-toolbar-note {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #9ca3af;
}

.analysis-btn-small {
  padding: 5px 10px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.analysis-btn-primary {
  background: #3b82f6;
  color: #fff;
  border-color: transparent;   /* .analysis-btn 기본 테두리가 파란 버튼에 남지 않도록 */
}

[data-theme="dark"] .analysis-btn-primary {
  border-color: transparent;
}

.analysis-btn-primary:hover {
  background: #2563eb;
}

.analysis-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.analysis-spin {
  animation: analysis-spin-rotate 900ms linear infinite;
}

@keyframes analysis-spin-rotate {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .analysis-spin { animation: none; }
}

.analysis-error {
  background: #fee2e2;
  color: #991b1b;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 10px;
}

.analysis-table-container {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.analysis-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.analysis-table th {
  position: sticky;
  top: 0;
  background: #f9fafb;
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #e5e7eb;
  color: #6b7280;
  font-weight: 600;
  white-space: nowrap;
}

.analysis-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

/* 수치 컬럼 — 오른쪽 정렬 + 등폭 숫자로 자릿수를 세로로 맞춘다.
   th 는 .analysis-table th 의 text-align:left 를 덮어써야 하므로 선택자를 같은 강도로 맞춘다. */
.analysis-table th.analysis-num,
.analysis-table td.analysis-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* 실행 중인 쿼리 — 머리글을 눌러 정렬, 정렬 기준 칸은 옅게 칠한다 */
.analysis-table th.analysis-th-sortable { padding: 0; }
.analysis-table th.analysis-th-sortable > button {
  all: unset;
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  text-align: inherit;
  transition: color 150ms ease, background-color 150ms ease;
}
.analysis-table th.analysis-th-sortable > button:hover { color: #2563eb; }
.analysis-table th.analysis-th-sortable > button:focus-visible { outline: 2px solid #2563eb; outline-offset: -2px; }
.analysis-table th.is-sorted { color: #1d4ed8; }
.analysis-table td.is-sorted { background: rgba(37, 99, 235, 0.06); font-weight: 600; }
[data-theme="dark"] .analysis-table th.is-sorted { color: #93c5fd; }
[data-theme="dark"] .analysis-table td.is-sorted { background: rgba(147, 197, 253, 0.08); }
@media (prefers-reduced-motion: reduce) {
  .analysis-table th.analysis-th-sortable > button { transition: none; }
}

.analysis-table-compact th,
.analysis-table-compact td {
  padding: 5px 8px;
  font-size: 11.5px;
}

.analysis-mono {
  font-family: var(--font-mono);
  white-space: nowrap;
}

.analysis-op-cell {
  font-family: var(--font-mono);
  white-space: nowrap;
}

/* 그리드 컬럼 출처(동적뷰)별 토글 칩 */
.analysis-source-toggles {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 2px 2px 8px;
}

.analysis-source-label {
  font-size: 11px;
  color: #9ca3af;
  margin-right: 2px;
}

.analysis-source-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  font-size: 11px;
  font-family: var(--font-mono);
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: transparent;
  color: #4b5563;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease, opacity 150ms ease;
}

.analysis-source-chip.on {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
}

.analysis-source-chip.off {
  opacity: 0.55;
  text-decoration: line-through;
}

/* 토글은 켜져 있지만(on) 이 스냅샷엔 그 소스의 실제 데이터가 없는 경우 — 점선 테두리로 구분 */
.analysis-source-chip.unused {
  opacity: 0.5;
  border-style: dashed;
}

.analysis-source-chip:hover {
  border-color: #3b82f6;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-source-chip { transition: none; }
}

[data-theme="dark"] .analysis-source-label {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-source-chip {
  border-color: var(--color-border);
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-source-chip.on {
  border-color: var(--color-accent-fg);
  background: rgba(59, 130, 246, 0.18);
  color: #93c5fd;
}

/* 실행계획 트리 들여쓰기 — depth 는 inline style 로 주고, 여기서는 가지 표시만 담당 */
.analysis-op-indent {
  display: inline-block;
}

.analysis-op-branch {
  display: inline-block;
  width: 10px;
  margin-right: 4px;
  border-bottom: 1px solid #d1d5db;
  vertical-align: middle;
  transform: translateY(-2px);
}

[data-theme="dark"] .analysis-op-branch {
  border-bottom-color: var(--color-border, #4b5563);
}

.analysis-sql-cell {
  max-width: 340px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-mono);
}

.analysis-row-demo {
  background: #fffbeb;
}

.analysis-badge-demo {
  display: inline-block;
  background: #fde68a;
  color: #92400e;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  margin-right: 6px;
}

.analysis-badge-parallel {
  display: inline-block;
  background: #dbeafe;
  color: #1e40af;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 8px;
}

.analysis-row-actions {
  white-space: nowrap;
}

.analysis-row-inline-panel td {
  background: #f9fafb;
  padding: 0;
}

.analysis-interval-panel {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  font-size: 12px;
  color: #374151;
}

.analysis-radio {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.analysis-empty-cell {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
  font-size: 13px;
}

/* 탭 B: 수집 결과 */
.analysis-collections-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  gap: 8px;
}

.analysis-sql-preview {
  font-family: var(--font-mono);
  font-size: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-snapshot-layout {
  display: flex;
  flex: 1 1;
  min-height: 0;
  gap: 12px;
}

.analysis-snapshot-list {
  width: 140px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px;
}

.analysis-snapshot-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 7px 10px;
  border: none;
  background: none;
  border-radius: 6px;
  font-size: 12px;
  color: #374151;
  text-align: left;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}

.analysis-snapshot-item:hover {
  background: #f3f4f6;
}

.analysis-snapshot-item.active {
  background: #dbeafe;
  color: #1e40af;
  font-weight: 600;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-snapshot-item { transition: none; }
}

.analysis-snapshot-detail {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}

.analysis-parallel-box {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
}

.analysis-parallel-box strong {
  display: block;
  margin-bottom: 6px;
  color: #1e40af;
}

.analysis-plan-table-container {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.analysis-report-details {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
}

.analysis-report-details summary {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.analysis-report-pre {
  margin: 8px 0 0 0;
  padding: 8px 10px;
  /* 고정폭 유지 — 리포트 원문은 칸을 맞춘 표다. 11px·옅은 회색은 다크 모드에서 읽기 어려웠다(2026-11-02 신고) */
  font-family: Consolas, 'D2Coding', 'Nanum Gothic Coding', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  color: #1f2937;
  background: #f9fafb;
  border-radius: 6px;
  max-height: 240px;
  overflow-y: auto;
}

/* 수집 시작 시 백엔드 경고(진단/튜닝 팩 설정 등) */
.analysis-warning {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  animation: analysis-fade-swap 160ms ease-out;
}

.analysis-warning ul {
  margin: 0;
  padding-left: 16px;
}

.analysis-warning li + li {
  margin-top: 2px;
}

/* LiveSQL 백엔드 미도달 — 예시/수집 결과가 통째로 비는 사유 안내 */
.analysis-backend-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 20px 0;
  padding: 9px 12px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  color: #991b1b;
  font-size: 12px;
  line-height: 1.5;
  animation: analysis-fade-swap 160ms ease-out;
}

.analysis-backend-error span {
  flex: 1 1;
}

.analysis-backend-error button {
  flex-shrink: 0;
  padding: 4px 10px;
  font-size: 12px;
  border: 1px solid currentColor;
  border-radius: 5px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.analysis-backend-error button:hover {
  background: rgba(153, 27, 27, 0.12);
}

@media (prefers-reduced-motion: reduce) {
  .analysis-backend-error { animation: none; }
  .analysis-backend-error button { transition: none; }
}

/* 실측 통계 출처 안내 (값이 비어 보이는 이유 설명) */
.analysis-stats-note {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #9ca3af;
  padding: 2px 2px 6px;
}

/* 실행 이력(AWR) 탭 툴바 */
.analysis-history-sqlid {
  font-size: 12px;
  color: #6b7280;
}

.analysis-history-sqlid strong {
  color: #374151;
  margin-left: 4px;
}

.analysis-history-days {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}

[data-theme="dark"] .analysis-history-sqlid,
[data-theme="dark"] .analysis-history-days {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-history-sqlid strong {
  color: var(--color-text);
}

/* 바인드 변수 표 */
.analysis-binds-source {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 400;
  font-family: var(--font-mono);
  color: #9ca3af;
}

.analysis-binds-table {
  margin-top: 8px;
}

.analysis-bind-value {
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-bind-null {
  color: #9ca3af;
  font-style: italic;
}

[data-theme="dark"] .analysis-binds-source,
[data-theme="dark"] .analysis-bind-null {
  color: var(--color-text-muted);
}

/* 조건절 정보 (Predicate Information) */
.analysis-predicate-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 180px;
  overflow-y: auto;
}

.analysis-predicate-item {
  display: flex;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 11px;
}

.analysis-predicate-id {
  flex-shrink: 0;
  min-width: 24px;
  text-align: right;
  color: #6b7280;
  font-weight: 600;
}

.analysis-predicate-text {
  white-space: pre-wrap;
  word-break: break-all;
  color: #4b5563;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-warning { animation: none; }
}

/* 다크 모드 */
[data-theme="dark"] .analysis-tabs {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .analysis-tab {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-tab:hover {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-tab.active {
  color: var(--color-accent-fg);
  border-bottom-color: var(--color-accent-fg);
}

[data-theme="dark"] .analysis-toolbar-note {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-table-container,
[data-theme="dark"] .analysis-plan-table-container,
[data-theme="dark"] .analysis-snapshot-list,
[data-theme="dark"] .analysis-report-details {
  border-color: var(--color-border);
}

[data-theme="dark"] .analysis-table th {
  background: var(--color-bg-secondary);
  color: var(--color-text-muted);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .analysis-table td {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .analysis-row-demo {
  background: rgba(253, 230, 138, 0.08);
}

[data-theme="dark"] .analysis-row-inline-panel td,
[data-theme="dark"] .analysis-sql-preview {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .analysis-interval-panel {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-snapshot-item {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-snapshot-item:hover {
  background: var(--color-hover);
}

[data-theme="dark"] .analysis-snapshot-item.active {
  background: rgba(59, 130, 246, 0.2);
  color: var(--color-accent-fg);
}

[data-theme="dark"] .analysis-parallel-box {
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.3);
}

[data-theme="dark"] .analysis-report-details summary {
  color: var(--color-text);
}

[data-theme="dark"] .analysis-report-pre {
  /* --color-text-muted(#777) 는 어두운 바탕에서 흐렸다 — 본문 글자색보다 한 단계 밝게, 획도 조금 굵게 */
  color: #e4e4e4;
  background: var(--color-bg-secondary, #252526);
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}

/* 라이트 팔레트 그대로면 다크에서 눈에 띄게 밝은 판이 된다 — 톤 다운한 대응색으로 교체 */
[data-theme="dark"] .analysis-error {
  background: rgba(248, 113, 113, 0.12);
  border: 1px solid rgba(248, 113, 113, 0.3);
  color: #fca5a5;
}

[data-theme="dark"] .analysis-badge-demo {
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
}

[data-theme="dark"] .analysis-badge-parallel {
  background: rgba(96, 165, 250, 0.18);
  color: #93c5fd;
}

[data-theme="dark"] .analysis-backend-error {
  background: rgba(248, 113, 113, 0.12);
  border-color: rgba(248, 113, 113, 0.35);
  color: #fca5a5;
}

[data-theme="dark"] .analysis-backend-error button:hover {
  background: rgba(248, 113, 113, 0.18);
}

[data-theme="dark"] .analysis-warning {
  background: rgba(251, 191, 36, 0.12);
  border-color: rgba(251, 191, 36, 0.35);
  color: #fbbf24;
}

[data-theme="dark"] .analysis-stats-note {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-predicate-id,
[data-theme="dark"] .analysis-predicate-text {
  color: var(--color-text-muted);
}

[data-theme="dark"] .analysis-btn-primary {
  background: var(--color-accent);
}

[data-theme="dark"] .analysis-btn-primary:hover {
  filter: brightness(1.1);
}

/* 실시간 성능에서 넘어온 조회 조건 표시 — 지금 보는 목록이 '전체'가 아님을 분명히 한다 */
.analysis-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1e40af;
  font-size: 11px;
}
.analysis-filter-chip code {
  font-family: var(--font-mono);
  background: rgba(255,255,255,0.7);
  padding: 1px 5px;
  border-radius: 3px;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.analysis-filter-chip .analysis-filter-window { opacity: 0.75; }
.analysis-filter-chip button {
  display: flex; align-items: center;
  border: none; background: none; cursor: pointer;
  color: #1e40af; padding: 0 0 0 2px;
}
.analysis-filter-chip button:hover { color: #1e3a8a; }

[data-theme="dark"] .analysis-filter-chip {
  background: rgba(59,130,246,0.15);
  border-color: rgba(59,130,246,0.4);
  color: #93c5fd;
}
[data-theme="dark"] .analysis-filter-chip code { background: rgba(0,0,0,0.3); }
[data-theme="dark"] .analysis-filter-chip button { color: #93c5fd; }

/* 툴바 컨트롤 공통 높이 — dbmsperf 쪽과 같은 값.
   두 모달이 '오라클 성능 분석' 한 창의 탭이라 높이가 갈리면 탭을 옮길 때 줄이 튄다. */
.analysis-btn,
.analysis-select {
  height: 30px;
  box-sizing: border-box;
  padding: 0 14px;
  font-size: 13px;
}
/* 아이콘과 글자를 같은 줄에 — 한글 글꼴은 줄 상자가 높아 글자가 아래로 앉아, 작은 아이콘이 위로 떠 보였다(2026-10-03).
   줄 높이를 글자 크기로 좁히고 아이콘은 블록으로(기준선 여백 없이) 세운다 */
.analysis-btn { line-height: 1; }
.analysis-btn > svg { display: block; }
.analysis-select { padding: 0 12px; }

/* 마지막 새로고침 시각 — 툴바 오른쪽, "쿼리보기" 버튼 바로 앞 */
.analysis-refreshed-at {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
}
[data-theme="dark"] .analysis-refreshed-at { color: var(--color-text-muted); }

/* "쿼리보기" 팝오버 */
.analysis-queryview-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
.analysis-queryview-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: calc(92vw / var(--app-zoom, 1));
  max-height: calc(80vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: analysis-fade-swap 160ms ease-out;
}
@media (prefers-reduced-motion: reduce) { .analysis-queryview-panel { animation: none; } }
.analysis-queryview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.analysis-queryview-body {
  flex: 1 1;
  overflow: auto;
  margin: 0;
  padding: 12px 14px;
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #1f2937;
}
.analysis-queryview-note {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-top: 1px solid #e5e7eb;
  font-size: 11px;
  color: #6b7280;
  background: #fafbfc;
}
[data-theme="dark"] .analysis-queryview-panel { background: var(--color-bg-tertiary); }
[data-theme="dark"] .analysis-queryview-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .analysis-queryview-body { color: var(--color-text); }
[data-theme="dark"] .analysis-queryview-note { background: var(--color-bg-secondary); border-top-color: var(--color-border); color: var(--color-text-muted); }

/* 실행 이력 — SQL_ID 직접 입력 */
.analysis-sqlid-input {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #9ca3af;
}
.analysis-sqlid-input input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12.5px;
  color: #374151;
  width: 140px;
}
[data-theme="dark"] .analysis-sqlid-input { border-color: var(--color-input-border); }
[data-theme="dark"] .analysis-sqlid-input input { color: var(--color-text); }

/* 최근 조회한 SQL_ID 리본(칩) */
.analysis-recent-sqlids {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 2px 8px;
}
.analysis-recent-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.02em;
  margin-right: 2px;
}
.analysis-recent-chip {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 11px;
  font-family: var(--font-mono);
  color: #374151;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.analysis-recent-chip:hover { background: #f3f4f6; }
.analysis-recent-chip.active { border-color: #3b82f6; background: rgba(59,130,246,0.1); color: #1d4ed8; }
@media (prefers-reduced-motion: reduce) { .analysis-recent-chip { transition: none; } }
[data-theme="dark"] .analysis-recent-label { color: var(--color-text-muted); }
[data-theme="dark"] .analysis-recent-chip { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .analysis-recent-chip:hover { background: var(--color-hover); }
[data-theme="dark"] .analysis-recent-chip.active { border-color: var(--color-accent-fg); background: rgba(59,130,246,0.18); color: #93c5fd; }

/* 「문장 전체」 요약 줄 — GV\$SQL_MONITOR 의 문장 한 행.
   아래 plan line 그리드가 리포트와 맞는지 대조할 기준점이다(2026-09-21). */
.analysis-stmt-total {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 6px 10px;
  margin: 0 0 6px 0;
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 4px;
  background: var(--color-bg-secondary, #f8f9fa);
  font-size: 11px;
}
.analysis-stmt-label {
  font-weight: 600;
  color: var(--color-text, #1f2937);
}
.analysis-stmt-item {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}
.analysis-stmt-k { color: var(--color-text-muted, #9ca3af); }
.analysis-stmt-v {
  font-family: var(--font-mono);
  color: var(--color-text, #1f2937);
}
.analysis-stmt-badge {
  padding: 1px 7px;
  border-radius: 9px;
  background: var(--color-bg-tertiary, #eceef1);
  color: var(--color-text-secondary, #4b5563);
}
/* 합계가 달라도 정상이라는 사실을 늘 옆에 둔다 — 없으면 또 "왜 다르냐"가 된다 */
.analysis-stmt-note {
  flex-basis: 100%;
  font-size: 10px;
  line-height: 1.5;
  color: var(--color-text-muted, #9ca3af);
}

[data-theme="dark"] .analysis-stmt-total {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .analysis-stmt-badge { background: var(--color-bg-secondary); }

/* 칸의 성격을 알리는 표시 — 「DB Time 은 활성세션 기준」 같은 것 */
.analysis-col-hint {
  display: inline-block;
  margin-left: 3px;
  font-style: normal;
  font-size: 9px;
  opacity: 0.5;
  cursor: help;
}

/* 옛 스냅샷·ASH 잘림 안내 — 값을 지우지 않고 그 사실을 말한다 */
.analysis-legacy-note {
  padding: 5px 9px;
  margin: 0 0 6px 0;
  border: 1px solid #fde68a;
  border-left-width: 3px;
  border-radius: 3px;
  background: #fffbeb;
  color: #92400e;
  font-size: 11px;
  line-height: 1.5;
}
[data-theme="dark"] .analysis-legacy-note {
  background: #3a2a00;
  color: #ffc107;
  border-color: #665500;
}

/* 중단 사유 배지 — 자동중단이 생긴 뒤로는 "왜 멈췄나" 가 곧바로 첫 질문이 된다.
   사유 자체는 나쁜 소식이 아니므로(대개 '실행 완료') 경고색을 쓰지 않는다. */
.analysis-stop-reason {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  line-height: 18px;
  background: #e5e7eb;
  color: #4b5563;
  border: 1px solid #d1d5db;
  cursor: help;
  white-space: nowrap;
}

[data-theme="dark"] .analysis-stop-reason {
  background: var(--color-btn-bg);
  color: var(--color-text-secondary, #9ca3af);
  border-color: var(--color-btn-border);
}

/* ── 목록 조건 툴바 (S4) ─────────────────────────────────────────── */
/* 기간·정렬은 좁아도 읽히므로 기본 min-width(160px)를 줄인다 — 한 줄에 다 들어가야
   "조건을 바꾸면 목록이 바뀐다" 가 한눈에 보인다. */
.analysis-toolbar .analysis-select-inline {
  min-width: 120px;
}

.analysis-input-inline {
  width: 180px;
  padding: 5px 10px;
  font-size: 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #111827;
  transition: border-color 150ms ease, background 150ms ease;
}

.analysis-input-inline:focus {
  outline: none;
  border-color: #6366f1;
}

[data-theme="dark"] .analysis-input-inline {
  background: var(--color-input-bg, var(--color-btn-bg));
  color: var(--color-text);
  border-color: var(--color-btn-border);
}

/* 실행 상태 칩 — "판정 못 함" 을 "종료" 와 다른 색으로 둔다.
   모른다는 것과 끝났다는 것은 다른 말이고, 같은 색이면 사용자가 구분할 방법이 없다. */
.analysis-state-chip {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 9px;
  font-size: 11px;
  line-height: 16px;
  white-space: nowrap;
  cursor: help;
}

.analysis-state-run    { background: #dcfce7; color: #15803d; border: 1px solid #86efac; }
.analysis-state-done   { background: #f3f4f6; color: #6b7280; border: 1px solid #e5e7eb; }
.analysis-state-unknown{ background: #fef3c7; color: #92400e; border: 1px solid #fde68a; }

[data-theme="dark"] .analysis-state-run    { background: #14532d; color: #bbf7d0; border-color: #166534; }
[data-theme="dark"] .analysis-state-done   { background: var(--color-btn-bg); color: var(--color-text-secondary, #9ca3af); border-color: var(--color-btn-border); }
[data-theme="dark"] .analysis-state-unknown{ background: #422006; color: #fde68a; border-color: #713f12; }

/* 모듈 셀을 눌러 그 모듈만 본다 — 버튼이지만 표 안에서는 링크처럼 보여야 한다 */
.analysis-link-cell {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #4f46e5;
  cursor: pointer;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  transition: color 150ms ease;
}

.analysis-link-cell:hover { color: #3730a3; }

[data-theme="dark"] .analysis-link-cell { color: #a5b4fc; }
[data-theme="dark"] .analysis-link-cell:hover { color: #c7d2fe; }

@media (prefers-reduced-motion: reduce) {
  .analysis-input-inline,
  .analysis-link-cell { transition: none; }
}

/* ── 실행 이력 2단 머리글 (S5) ───────────────────────────────────── */
/* 무리를 색으로 갈라 둔다 — "이 칸이 합계인가 실행당인가" 를 매번 헤아리게 하면
   2단 머리글을 둔 의미가 없다. */
.analysis-group-head th {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
  cursor: help;
}

.analysis-group-id     { background: #f9fafb; color: #6b7280; }
.analysis-group-delta  { background: #eef2ff; color: #4338ca; }
.analysis-group-perExec{ background: #ecfdf5; color: #047857; }

[data-theme="dark"] .analysis-group-head th { border-bottom-color: var(--color-btn-border); }
[data-theme="dark"] .analysis-group-id      { background: var(--color-btn-bg); color: var(--color-text-secondary, #9ca3af); }
[data-theme="dark"] .analysis-group-delta   { background: #1e1b4b; color: #c7d2fe; }
[data-theme="dark"] .analysis-group-perExec { background: #064e3b; color: #a7f3d0; }

/* 「완료 0회」 배지 — 나쁜 소식이 아니라 **설명**이다(장시간 실행이 구간을 넘어갔다).
   경고색을 쓰면 오류로 읽힌다. */
.analysis-zeroexec-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 9px;
  font-size: 10px;
  line-height: 15px;
  white-space: nowrap;
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  cursor: help;
}

[data-theme="dark"] .analysis-zeroexec-badge {
  background: var(--color-btn-bg);
  color: var(--color-text-secondary, #9ca3af);
  border-color: var(--color-btn-border);
}

.analysis-history-chart {
  margin-bottom: 10px;
  animation: analysis-fade-swap 160ms ease-out;
}

.analysis-history-chart-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

@media (prefers-reduced-motion: reduce) {
  .analysis-history-chart { animation: none; }
}

/* ── 오브젝트별 읽기량 — 한 오브젝트를 한 줄에, 열마다 막대(2026-10-14) ───────────────── */
.analysis-objreads { width: 100%; border-collapse: collapse; font-size: 12px; animation: analysis-fade-swap 160ms ease-out; }
.analysis-objreads th { text-align: left; font-weight: 600; color: #6b7280; padding: 4px 8px; border-bottom: 1px solid #e5e7eb; white-space: nowrap; cursor: help; }
.analysis-objreads th:first-child { cursor: default; }
.analysis-objreads td { padding: 3px 8px; border-bottom: 1px solid #f3f4f6; }
.analysis-objreads-name { max-width: 240px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-family: var(--font-mono, Consolas, monospace); }
.analysis-objreads-cell { position: relative; display: flex; align-items: center; gap: 6px; min-width: 180px; height: 18px; }
.analysis-objreads-bar { position: absolute; left: 0; top: 3px; bottom: 3px; border-radius: 2px; opacity: 0.28; }
.analysis-objreads-bar.is-buffer { background: #3b82f6; }
.analysis-objreads-bar.is-physical { background: #10b981; }
.analysis-objreads-val { position: relative; margin-left: 4px; font-variant-numeric: tabular-nums; font-weight: 600; color: #374151; }
.analysis-objreads-pct { position: relative; font-size: 11px; color: #6b7280; font-variant-numeric: tabular-nums; }
[data-theme="dark"] .analysis-objreads th { color: var(--color-text-secondary, #9ca3af); border-bottom-color: var(--color-border); }
[data-theme="dark"] .analysis-objreads td { border-bottom-color: var(--color-border); }
[data-theme="dark"] .analysis-objreads-val { color: var(--color-text); }
[data-theme="dark"] .analysis-objreads-bar { opacity: 0.4; }
@media (prefers-reduced-motion: reduce) {
  .analysis-objreads { animation: none; }
}

/* 예시 데이터 체크 — 세션 분석·DBMS 성능과 같은 자리·모양(2026-10-03) */
/* 오른쪽 여백은 DBMS 성능 탭의 같은 줄(.dbmsperf-embedded-bar)과 같게 — 창 가장자리에 붙지 않게 */
.analysis-demo-bar { display: flex; justify-content: flex-end; align-items: center; padding: 6px 20px 0; flex-shrink: 0; }
.analysis-demo-toggle { display: flex; align-items: center; gap: 4px; font-size: 12px; color: #6b7280; cursor: pointer; }
[data-theme="dark"] .analysis-demo-toggle { color: var(--color-text-muted); }

/* 수집은 모니터링 권한의 것 — 권한이 없을 때 그 자리에서 말하는 줄(오류 배너가 아니다) */
.analysis-empty-note { padding: 8px 12px; margin-bottom: 8px; border-radius: 4px; font-size: 12px; background: rgba(217, 119, 6, 0.12); border: 1px solid rgba(217, 119, 6, 0.3); }

/* 실행 이력 — 최근 조회 칩마다 지우기(×) 단추(2026-10-14) */
.analysis-recent-chip-removable { display: inline-flex; align-items: center; padding: 0; cursor: default; overflow: hidden; }
.analysis-recent-chip-removable > button { all: unset; cursor: pointer; font: inherit; color: inherit; }
.analysis-recent-chip-main { padding: 2px 4px 2px 10px; }
.analysis-recent-chip-x { display: inline-flex; align-items: center; padding: 3px 7px 3px 3px; opacity: 0.55; transition: opacity 150ms ease, color 150ms ease; }
.analysis-recent-chip-x:hover { opacity: 1; color: #dc2626; }
.analysis-recent-chip-removable > button:focus-visible { outline: 2px solid #3b82f6; outline-offset: -2px; border-radius: 999px; }

/* 실행 이력 — 그래프 종류(소요시간 / 블록 읽기) */
.analysis-seg { display: inline-flex; border: 1px solid #d1d5db; border-radius: 6px; overflow: hidden; margin-right: 6px; }
.analysis-seg > button { all: unset; cursor: pointer; padding: 3px 10px; font-size: 11px; color: #374151; transition: background-color 150ms ease, color 150ms ease; }
.analysis-seg > button + button { border-left: 1px solid #d1d5db; }
.analysis-seg > button:hover { background: #f3f4f6; }
.analysis-seg > button.active { background: #2563eb; color: #fff; }
.analysis-seg > button:focus-visible { outline: 2px solid #2563eb; outline-offset: -2px; }
.analysis-chart-note { font-size: 11px; color: #6b7280; margin: 2px 0 4px; animation: analysis-fade-swap 160ms ease-out; }
[data-theme="dark"] .analysis-seg { border-color: var(--color-border); }
[data-theme="dark"] .analysis-seg > button { color: var(--color-text-secondary); }
[data-theme="dark"] .analysis-seg > button + button { border-left-color: var(--color-border); }
[data-theme="dark"] .analysis-seg > button:hover { background: var(--color-hover); }
[data-theme="dark"] .analysis-seg > button.active { background: #2563eb; color: #fff; }
[data-theme="dark"] .analysis-chart-note { color: var(--color-text-muted); }

/* 상세 목록 — 고른 그래프와 관련된 컬럼을 칠한다 */
.analysis-history-details > summary { cursor: pointer; }
.analysis-table th.is-related { color: #1d4ed8; background: #eff6ff; }
.analysis-table td.is-related { background: rgba(37, 99, 235, 0.06); }
[data-theme="dark"] .analysis-table th.is-related { color: #93c5fd; background: rgba(59, 130, 246, 0.16); }
[data-theme="dark"] .analysis-table td.is-related { background: rgba(147, 197, 253, 0.08); }
@media (prefers-reduced-motion: reduce) {
  .analysis-seg > button, .analysis-recent-chip-x { transition: none; }
  .analysis-chart-note { animation: none; }
}

.analysis-table td.analysis-nowrap { white-space: nowrap; }

/* 실행 이력 — 노드마다 한 장(RAC) */
.analysis-history-inst + .analysis-history-inst { margin-top: 4px; border-top: 1px dashed #e5e7eb; padding-top: 2px; }
.analysis-history-inst-label { font-size: 11px; font-weight: 600; color: #4b5563; margin: 2px 0 0 4px; }
[data-theme="dark"] .analysis-history-inst-label { color: var(--color-text-muted); }
[data-theme="dark"] .analysis-history-inst + .analysis-history-inst { border-top-color: var(--color-border); }

/* 실행 이력 — SQL 텍스트로 찾은 후보(2026-10-22) */
.analysis-sqlsearch { margin: 6px 0; border: 1px solid var(--color-border, #e5e7eb); border-radius: 6px; animation: analysis-sqlsearch-in 160ms ease-out; }
@keyframes analysis-sqlsearch-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
.analysis-sqlsearch-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 6px 8px; font-size: 12px; }
.analysis-sqlsearch-list { max-height: 240px; overflow: auto; border-top: 1px solid var(--color-border, #e5e7eb); }
.analysis-sqlsearch-row { cursor: pointer; transition: background-color 150ms ease; }
.analysis-sqlsearch-row:hover { background: rgba(37, 99, 235, 0.08); }
.analysis-sqlsearch-row.active { background: rgba(37, 99, 235, 0.16); }
.analysis-sqlsearch-text { max-width: 640px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
@media (prefers-reduced-motion: reduce) { .analysis-sqlsearch { animation: none; } .analysis-sqlsearch-row { transition: none; } }

/* ── 실행 중인 쿼리 · 페치 대기 · 작은 아이콘 단추 (2026-10-27) ── */
.analysis-state-fetch  { background: #e0f2fe; color: #075985; border: 1px solid #7dd3fc; }
[data-theme="dark"] .analysis-state-fetch { background: #0c4a6e; color: #bae6fd; border-color: #075985; }
.analysis-badge-fetch {
  display: inline-block; margin-left: 6px; padding: 1px 6px; border-radius: 4px;
  background: #e0f2fe; color: #075985; font-size: 10px; font-weight: 600;
}
[data-theme="dark"] .analysis-badge-fetch { background: #0c4a6e; color: #bae6fd; }
.analysis-row-actions .analysis-icon-btn { vertical-align: middle; }
.analysis-row-actions .analysis-icon-btn + .analysis-icon-btn { margin-left: 3px; }
.analysis-icon-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 24px; height: 22px; padding: 0; border: 1px solid #d1d5db; border-radius: 4px;
  background: #fff; color: #4b5563; cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.analysis-icon-btn:hover:not(:disabled) { background: #f3f4f6; color: #111827; border-color: #9ca3af; }
.analysis-icon-btn.is-primary { color: #2563eb; border-color: #93c5fd; }
.analysis-icon-btn.is-primary:hover:not(:disabled), .analysis-icon-btn.on { background: #eff6ff; color: #1d4ed8; }
.analysis-icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }
[data-theme="dark"] .analysis-icon-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .analysis-icon-btn:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .analysis-icon-btn.is-primary { color: #93c5fd; }
.analysis-collect-error { margin: 6px; font-size: 11px; word-break: break-all; }
@media (prefers-reduced-motion: reduce) { .analysis-icon-btn { transition: none; } }

/* ── 실행 중인 쿼리 — 표 본문만 스크롤(2026-11-03 시험 피드백) ─────────────────
   도구 줄·리본·표 머리는 서 있고 표 칸(analysis-table-container)만 스크롤된다. 머리(th)는 원래 sticky 다 */
.analysis-active-pane {
  flex: 1 1 auto;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.analysis-active-pane > .analysis-toolbar,
.analysis-active-pane > .analysis-ribbon,
.analysis-active-pane > .analysis-error { flex-shrink: 0; }
.analysis-active-pane > .analysis-table-container { flex: 1 1 auto; min-height: 0; }
.analysis-modal-body:has(> .analysis-active-pane) { overflow: hidden; }

/* 리본 — 노드 고르기 · 실행 상태 거르기 */
.analysis-ribbon {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.analysis-ribbon-chip {
  padding: 2px 9px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #fff;
  color: #374151;
  font-size: 11.5px;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.analysis-ribbon-chip:hover { background: #f3f4f6; }
.analysis-ribbon-chip.on { background: #dbeafe; border-color: #60a5fa; color: #1d4ed8; font-weight: 600; }
.analysis-ribbon-count { font-variant-numeric: tabular-nums; opacity: 0.75; margin-left: 2px; }
.analysis-state-chip-run.on { background: #dcfce7; border-color: #86efac; color: #15803d; }
.analysis-state-chip-fetch.on { background: #e0f2fe; border-color: #7dd3fc; color: #075985; }
[data-theme="dark"] .analysis-ribbon-chip { background: var(--color-btn-bg, #374151); border-color: var(--color-border, #4b5563); color: var(--color-text, #e5e7eb); }
[data-theme="dark"] .analysis-ribbon-chip:hover { background: var(--color-hover, #4b5563); }
[data-theme="dark"] .analysis-ribbon-chip.on { background: #1e3a8a; border-color: #1d4ed8; color: #dbeafe; }
[data-theme="dark"] .analysis-state-chip-run.on { background: #14532d; border-color: #166534; color: #bbf7d0; }
[data-theme="dark"] .analysis-state-chip-fetch.on { background: #0c4a6e; border-color: #075985; color: #bae6fd; }

/* SQL 칸 — 누르면 전문 창 */
.analysis-sql-cell.is-clickable { cursor: pointer; }
.analysis-sql-cell.is-clickable:hover { -webkit-text-decoration: underline dotted; text-decoration: underline dotted; }

@media (prefers-reduced-motion: reduce) {
  .analysis-ribbon-chip { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/MonitoringAnalysisModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,UAAU;EACV,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;;qDAEmD;EACnD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kFAAkF;;EAElF;;kCAEgC;EAChC,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;wEAEwE;;AAExE;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB,eAAe,EAAE;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB,IAAI,wCAAwC;AACvE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB,eAAe,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;0EAC0E;AAC1E;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C,0CAA0C,UAAU,EAAE;AACtD;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yDAAyD;AAC3D;AACA,yDAAyD,cAAc,EAAE;AACzE,iEAAiE,0BAA0B,EAAE,oBAAoB,EAAE;AACnH,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,mCAAmC,EAAE,gBAAgB,EAAE;AACtF,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,qCAAqC,EAAE;AAC1F;EACE,mDAAmD,gBAAgB,EAAE;AACvE;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sGAAsG;AACxG;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB,gBAAgB,EAAE;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B,gBAAgB,EAAE;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0EAA0E;EAC1E,kFAAkF;EAClF,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B,eAAe,EAAE;EAC3C,iCAAiC,gBAAgB,EAAE;AACrD;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,sDAAsD;AACtD;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,gDAAgD,aAAa,EAAE;AAC/D;EACE,aAAa,EAAE,mBAAmB;EAClC,YAAY,EAAE,gBAAgB,EAAE,eAAe;EAC/C,cAAc,EAAE,kBAAkB;AACpC;AACA,qCAAqC,cAAc,EAAE;;AAErD;EACE,iCAAiC;EACjC,kCAAkC;EAClC,cAAc;AAChB;AACA,iDAAiD,2BAA2B,EAAE;AAC9E,mDAAmD,cAAc,EAAE;;AAEnE;sDACsD;AACtD;;EAEE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;8CAC8C;AAC9C,gBAAgB,cAAc,EAAE;AAChC,sBAAsB,cAAc,EAAE;AACtC,mBAAmB,eAAe,EAAE;;AAEpC,yCAAyC;AACzC;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,6CAA6C,8BAA8B,EAAE;;AAE7E,eAAe;AACf;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA,0CAA0C,4BAA4B,eAAe,EAAE,EAAE;AACzF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAO;EACP,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,gDAAgD,oCAAoC,EAAE;AACtF,iDAAiD,qCAAqC,EAAE,wCAAwC,EAAE,wBAAwB,EAAE;AAC5J,+CAA+C,wBAAwB,EAAE;AACzE,+CAA+C,qCAAqC,EAAE,qCAAqC,EAAE,8BAA8B,EAAE;;AAE7J,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA,4CAA4C,uCAAuC,EAAE;AACrF,kDAAkD,wBAAwB,EAAE;;AAE5E,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;AACA,8BAA8B,mBAAmB,EAAE;AACnD,+BAA+B,qBAAqB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACxG,0CAA0C,wBAAwB,gBAAgB,EAAE,EAAE;AACtF,6CAA6C,8BAA8B,EAAE;AAC7E,4CAA4C,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AACxJ,kDAAkD,8BAA8B,EAAE;AAClF,mDAAmD,oCAAoC,EAAE,iCAAiC,EAAE,cAAc,EAAE;;AAE5I;sDACsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA,mBAAmB,uCAAuC,EAAE;AAC5D;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA,2CAA2C,qCAAqC,EAAE;;AAElF,6CAA6C;AAC7C;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;gDACgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA,iEAAiE;AACjE;iCACiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;EACtD,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;oDACoD;AACpD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACzF,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACzF,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEzF,6CAA6C,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACzG,6CAA6C,+BAA+B,EAAE,2CAA2C,EAAE,qCAAqC,EAAE;AAClK,6CAA6C,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAEzG,iDAAiD;AACjD;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,yCAAiC;UAAjC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C,0CAA0C,cAAc,EAAE;AAC1D,gDAAgD,cAAc,EAAE;;AAEhE;EACE;wBACsB,gBAAgB,EAAE;AAC1C;;AAEA,+DAA+D;AAC/D;sBACsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D,8CAA8C,4CAA4C,EAAE;AAC5F,8CAA8C,+BAA+B,EAAE,2CAA2C,EAAE;AAC5H,8CAA8C,mBAAmB,EAAE,cAAc,EAAE;AACnF,8CAA8C,mBAAmB,EAAE,cAAc,EAAE;;AAEnF;qBACqB;AACrB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,0BAA0B,eAAe,EAAE;AAC7C;;AAEA,sEAAsE;AACtE,qBAAqB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE,4CAA4C,EAAE;AAC5H,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,mBAAmB,EAAE,YAAY,EAAE;AACnK,oCAAoC,eAAe,EAAE;AACrD,wBAAwB,gBAAgB,EAAE,gCAAgC,EAAE;AAC5E,0BAA0B,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,kDAAkD,EAAE;AAChK,0BAA0B,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,YAAY,EAAE;AAC5H,yBAAyB,kBAAkB,EAAE,OAAO,EAAE,QAAQ,EAAE,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE;AAChH,mCAAmC,mBAAmB,EAAE;AACxD,qCAAqC,mBAAmB,EAAE;AAC1D,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrI,yBAAyB,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAClH,4CAA4C,2CAA2C,EAAE,wCAAwC,EAAE;AACnI,4CAA4C,wCAAwC,EAAE;AACtF,6CAA6C,wBAAwB,EAAE;AACvE,6CAA6C,YAAY,EAAE;AAC3D;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA,oDAAoD;AACpD,wEAAwE;AACxE,qBAAqB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACzH,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACxH,4CAA4C,8BAA8B,EAAE;;AAE5E,uDAAuD;AACvD,uBAAuB,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,mCAAmC,EAAE,wCAAwC,EAAE;;AAElL,4CAA4C;AAC5C,kCAAkC,oBAAoB,EAAE,mBAAmB,EAAE,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5H,2CAA2C,UAAU,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AACvG,6BAA6B,yBAAyB,EAAE;AACxD,0BAA0B,oBAAoB,EAAE,mBAAmB,EAAE,wBAAwB,EAAE,aAAa,EAAE,gDAAgD,EAAE;AAChK,gCAAgC,UAAU,EAAE,cAAc,EAAE;AAC5D,yDAAyD,0BAA0B,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;;AAEjI,iCAAiC;AACjC,gBAAgB,oBAAoB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC1H,yBAAyB,UAAU,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,yDAAyD,EAAE;AACrK,kCAAkC,8BAA8B,EAAE;AAClE,+BAA+B,mBAAmB,EAAE;AACpD,gCAAgC,mBAAmB,EAAE,WAAW,EAAE;AAClE,uCAAuC,0BAA0B,EAAE,oBAAoB,EAAE;AACzF,uBAAuB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,4CAA4C,EAAE;AACzH,oCAAoC,iCAAiC,EAAE;AACvE,6CAA6C,kCAAkC,EAAE;AACjF,sDAAsD,sCAAsC,EAAE;AAC9F,mDAAmD,8BAA8B,EAAE;AACnF,oDAAoD,mBAAmB,EAAE,WAAW,EAAE;AACtF,2CAA2C,8BAA8B,EAAE;;AAE3E,gCAAgC;AAChC,sCAAsC,eAAe,EAAE;AACvD,gCAAgC,cAAc,EAAE,mBAAmB,EAAE;AACrE,gCAAgC,mCAAmC,EAAE;AACrE,oDAAoD,cAAc,EAAE,oCAAoC,EAAE;AAC1G,oDAAoD,qCAAqC,EAAE;AAC3F;EACE,kDAAkD,gBAAgB,EAAE;EACpE,uBAAuB,eAAe,EAAE;AAC1C;;AAEA,qCAAqC,mBAAmB,EAAE;;AAE1D,0BAA0B;AAC1B,kDAAkD,eAAe,EAAE,8BAA8B,EAAE,gBAAgB,EAAE;AACrH,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACvG,mDAAmD,8BAA8B,EAAE;AACnF,sEAAsE,qCAAqC,EAAE;;AAE7G,uCAAuC;AACvC,sBAAsB,aAAa,EAAE,8CAA8C,EAAE,kBAAkB,EAAE,+CAA+C,EAAE;AAC1J,mCAAmC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAClI,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5I,2BAA2B,iBAAiB,EAAE,cAAc,EAAE,kDAAkD,EAAE;AAClH,0BAA0B,eAAe,EAAE,uCAAuC,EAAE;AACpF,gCAAgC,mCAAmC,EAAE;AACrE,iCAAiC,mCAAmC,EAAE;AACtE,2BAA2B,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC7G,0CAA0C,sBAAsB,eAAe,EAAE,EAAE,0BAA0B,gBAAgB,EAAE,EAAE;;AAEjI,oDAAoD;AACpD,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACzF,4CAA4C,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACxG;EACE,qBAAqB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB;EAC7E,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB;AACxE;AACA,4CAA4C,mBAAmB,EAAE,cAAc,EAAE;AACjF,2CAA2C,sBAAsB,EAAE;AACnE,gEAAgE,gBAAgB,EAAE;AAClF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,yBAAyB,EAAE,kBAAkB;EACpF,gBAAgB,EAAE,cAAc,EAAE,eAAe;EACjD,kFAAkF;AACpF;AACA,0CAA0C,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACtG,gCAAgC,cAAc,EAAE,qBAAqB,EAAE;AACvE,4EAA4E,mBAAmB,EAAE,cAAc,EAAE;AACjH,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,yCAAyC,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AACrJ,8DAA8D,8BAA8B,EAAE,wBAAwB,EAAE;AACxH,oDAAoD,cAAc,EAAE;AACpE,0BAA0B,WAAW,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC/E,0CAA0C,qBAAqB,gBAAgB,EAAE,EAAE;;AAEnF;iFACiF;AACjF;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;0CAE0C,cAAc,EAAE;AAC1D,oDAAoD,cAAc,EAAE,aAAa,EAAE;AACnF,oDAAoD,gBAAgB,EAAE;;AAEtE,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kFAAkF;AACpF;AACA,8BAA8B,mBAAmB,EAAE;AACnD,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACzG,yBAAyB,kCAAkC,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC9F,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1F,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC5F,4CAA4C,wCAAwC,EAAE,0CAA0C,EAAE,iCAAiC,EAAE;AACrK,kDAAkD,uCAAuC,EAAE;AAC3F,+CAA+C,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC3G,kDAAkD,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9G,oDAAoD,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEhH,qBAAqB;AACrB,kCAAkC,eAAe,EAAE;AACnD,wCAAwC,yCAAiC,EAAjC,iCAAiC,EAAE;;AAE3E;EACE,wBAAwB,gBAAgB,EAAE;AAC5C","sourcesContent":[".analysis-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1001;\r\n}\r\n\r\n.analysis-modal {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  max-height: calc(80vh / var(--app-zoom, 1));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.analysis-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.analysis-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.analysis-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: #999;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.analysis-modal-close:hover {\r\n  color: #333;\r\n}\r\n\r\n.analysis-modal-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.analysis-conn-select {\r\n  max-width: 300px;\r\n}\r\n\r\n.analysis-label {\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.analysis-select {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: #374151;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.analysis-select:hover {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.analysis-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.analysis-content {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.analysis-loading {\r\n  font-size: 16px;\r\n  color: #6b7280;\r\n}\r\n\r\n.analysis-coming-soon {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.analysis-icon {\r\n  font-size: 64px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.analysis-coming-soon h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 24px;\r\n  color: #1f2937;\r\n}\r\n\r\n.analysis-coming-soon p {\r\n  margin: 0 0 30px 0;\r\n  font-size: 16px;\r\n  color: #6b7280;\r\n}\r\n\r\n.analysis-info {\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  text-align: left;\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.analysis-info h4 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 16px;\r\n  color: #1f2937;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.info-item span:first-child {\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n}\r\n\r\n.info-item span:last-child {\r\n  color: #374151;\r\n}\r\n\r\n.status-active {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-inactive {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.analysis-modal-footer {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 16px 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.analysis-btn {\r\n  /* 아이콘+텍스트 정렬 — 예전에는 텍스트 앞에 공백을 넣어 띄웠는데, 그러면 아이콘이\r\n     baseline 에 걸려 살짝 내려앉는다. flex 로 세로 중앙을 맞추고 간격은 gap 이 준다\r\n     (.dbmsperf-btn 과 같은 규칙 — 두 모달이 한 창의 탭으로 합쳐졌다). */\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease;\r\n\r\n  /* variant(-primary/-secondary) 없이 쓰는 버튼(결과 보기, 취소)이 브라우저 기본\r\n     버튼 색(밝은 회색 ButtonFace + 검은 글자)으로 떨어지는 것을 막는다.\r\n     다크모드에서 이 기본색이 흰 판처럼 튀어 보였다. */\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.analysis-btn:hover {\r\n  background: #e5e7eb;\r\n}\r\n\r\n/* 다크 기본값 — 아래의 -secondary / -primary 다크 규칙이 뒤에 오므로 그쪽이 우선한다 */\r\n[data-theme=\"dark\"] .analysis-btn {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-btn { transition: none; }\r\n}\r\n\r\n.analysis-btn-secondary {\r\n  background: #e5e7eb;\r\n  color: #374151;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.analysis-btn-secondary:hover {\r\n  background: #d1d5db;\r\n}\r\n\r\n/* Dark mode */\r\n[data-theme=\"dark\"] .analysis-modal {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-modal-header {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-modal-header h2 {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-modal-close {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-modal-close:hover {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-label {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-select {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-select:hover {\r\n  border-color: var(--color-hover-border, #5a5a5a);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-select:focus {\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-coming-soon h3 {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-coming-soon p {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-info {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-info h4 {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .info-item span:first-child {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .info-item span:last-child {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-modal-footer {\r\n  border-top-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn-secondary {\r\n  background: var(--color-btn-bg);\r\n  color: var(--color-text);\r\n  border: 1px solid var(--color-btn-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn-secondary:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n/* ===================================================================\r\n   오라클 SQL 성능 분석 — 탭 UI (실행 중인 쿼리 / 수집 결과)\r\n   =================================================================== */\r\n\r\n.analysis-modal-wide {\r\n  max-width: 1400px;\r\n  height: calc(85vh / var(--app-zoom, 1));\r\n}\r\n\r\n.analysis-modal-body-flex {\r\n  padding: 16px 20px;\r\n  gap: 12px;\r\n}\r\n\r\n@keyframes analysis-fade-swap {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.analysis-fade-swap {\r\n  animation: analysis-fade-swap 160ms ease-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-fade-swap { animation: none; }\r\n}\r\n\r\n.analysis-tabs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 0 20px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.analysis-tab {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px 14px;\r\n  border: none;\r\n  background: none;\r\n  color: #6b7280;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n  transition: color 150ms ease, border-color 150ms ease;\r\n}\r\n\r\n.analysis-tab:hover {\r\n  color: #374151;\r\n}\r\n\r\n.analysis-tab.active {\r\n  color: #3b82f6;\r\n  border-bottom-color: #3b82f6;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-tab { transition: none; }\r\n}\r\n\r\n.analysis-tabs-spacer {\r\n  flex: 1;\r\n}\r\n\r\n.analysis-select-inline {\r\n  width: auto;\r\n  min-width: 160px;\r\n  padding: 5px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.analysis-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.analysis-toolbar-note {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.analysis-btn-small {\r\n  padding: 5px 10px;\r\n  font-size: 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.analysis-btn-primary {\r\n  background: #3b82f6;\r\n  color: #fff;\r\n  border-color: transparent;   /* .analysis-btn 기본 테두리가 파란 버튼에 남지 않도록 */\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn-primary {\r\n  border-color: transparent;\r\n}\r\n\r\n.analysis-btn-primary:hover {\r\n  background: #2563eb;\r\n}\r\n\r\n.analysis-btn-primary:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.analysis-spin {\r\n  animation: analysis-spin-rotate 900ms linear infinite;\r\n}\r\n\r\n@keyframes analysis-spin-rotate {\r\n  from { transform: rotate(0deg); }\r\n  to   { transform: rotate(360deg); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-spin { animation: none; }\r\n}\r\n\r\n.analysis-error {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.analysis-table-container {\r\n  flex: 1;\r\n  overflow: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n}\r\n\r\n.analysis-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n}\r\n\r\n.analysis-table th {\r\n  position: sticky;\r\n  top: 0;\r\n  background: #f9fafb;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  color: #6b7280;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.analysis-table td {\r\n  padding: 7px 10px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  color: #374151;\r\n}\r\n\r\n/* 수치 컬럼 — 오른쪽 정렬 + 등폭 숫자로 자릿수를 세로로 맞춘다.\r\n   th 는 .analysis-table th 의 text-align:left 를 덮어써야 하므로 선택자를 같은 강도로 맞춘다. */\r\n.analysis-table th.analysis-num,\r\n.analysis-table td.analysis-num {\r\n  text-align: right;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* 실행 중인 쿼리 — 머리글을 눌러 정렬, 정렬 기준 칸은 옅게 칠한다 */\r\n.analysis-table th.analysis-th-sortable { padding: 0; }\r\n.analysis-table th.analysis-th-sortable > button {\r\n  all: unset;\r\n  box-sizing: border-box;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  text-align: inherit;\r\n  transition: color 150ms ease, background-color 150ms ease;\r\n}\r\n.analysis-table th.analysis-th-sortable > button:hover { color: #2563eb; }\r\n.analysis-table th.analysis-th-sortable > button:focus-visible { outline: 2px solid #2563eb; outline-offset: -2px; }\r\n.analysis-table th.is-sorted { color: #1d4ed8; }\r\n.analysis-table td.is-sorted { background: rgba(37, 99, 235, 0.06); font-weight: 600; }\r\n[data-theme=\"dark\"] .analysis-table th.is-sorted { color: #93c5fd; }\r\n[data-theme=\"dark\"] .analysis-table td.is-sorted { background: rgba(147, 197, 253, 0.08); }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-table th.analysis-th-sortable > button { transition: none; }\r\n}\r\n\r\n.analysis-table-compact th,\r\n.analysis-table-compact td {\r\n  padding: 5px 8px;\r\n  font-size: 11.5px;\r\n}\r\n\r\n.analysis-mono {\r\n  font-family: var(--font-mono);\r\n  white-space: nowrap;\r\n}\r\n\r\n.analysis-op-cell {\r\n  font-family: var(--font-mono);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 그리드 컬럼 출처(동적뷰)별 토글 칩 */\r\n.analysis-source-toggles {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  padding: 2px 2px 8px;\r\n}\r\n\r\n.analysis-source-label {\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  margin-right: 2px;\r\n}\r\n\r\n.analysis-source-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 9px;\r\n  font-size: 11px;\r\n  font-family: var(--font-mono);\r\n  border-radius: 999px;\r\n  border: 1px solid #d1d5db;\r\n  background: transparent;\r\n  color: #4b5563;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease, opacity 150ms ease;\r\n}\r\n\r\n.analysis-source-chip.on {\r\n  border-color: #3b82f6;\r\n  background: rgba(59, 130, 246, 0.1);\r\n  color: #1d4ed8;\r\n}\r\n\r\n.analysis-source-chip.off {\r\n  opacity: 0.55;\r\n  text-decoration: line-through;\r\n}\r\n\r\n/* 토글은 켜져 있지만(on) 이 스냅샷엔 그 소스의 실제 데이터가 없는 경우 — 점선 테두리로 구분 */\r\n.analysis-source-chip.unused {\r\n  opacity: 0.5;\r\n  border-style: dashed;\r\n}\r\n\r\n.analysis-source-chip:hover {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-source-chip { transition: none; }\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-source-label {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-source-chip {\r\n  border-color: var(--color-border);\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-source-chip.on {\r\n  border-color: var(--color-accent-fg);\r\n  background: rgba(59, 130, 246, 0.18);\r\n  color: #93c5fd;\r\n}\r\n\r\n/* 실행계획 트리 들여쓰기 — depth 는 inline style 로 주고, 여기서는 가지 표시만 담당 */\r\n.analysis-op-indent {\r\n  display: inline-block;\r\n}\r\n\r\n.analysis-op-branch {\r\n  display: inline-block;\r\n  width: 10px;\r\n  margin-right: 4px;\r\n  border-bottom: 1px solid #d1d5db;\r\n  vertical-align: middle;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-op-branch {\r\n  border-bottom-color: var(--color-border, #4b5563);\r\n}\r\n\r\n.analysis-sql-cell {\r\n  max-width: 340px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.analysis-row-demo {\r\n  background: #fffbeb;\r\n}\r\n\r\n.analysis-badge-demo {\r\n  display: inline-block;\r\n  background: #fde68a;\r\n  color: #92400e;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  margin-right: 6px;\r\n}\r\n\r\n.analysis-badge-parallel {\r\n  display: inline-block;\r\n  background: #dbeafe;\r\n  color: #1e40af;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.analysis-row-actions {\r\n  white-space: nowrap;\r\n}\r\n\r\n.analysis-row-inline-panel td {\r\n  background: #f9fafb;\r\n  padding: 0;\r\n}\r\n\r\n.analysis-interval-panel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 14px;\r\n  font-size: 12px;\r\n  color: #374151;\r\n}\r\n\r\n.analysis-radio {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.analysis-empty-cell {\r\n  text-align: center;\r\n  padding: 24px;\r\n  color: #9ca3af;\r\n  font-size: 13px;\r\n}\r\n\r\n/* 탭 B: 수집 결과 */\r\n.analysis-collections-layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n  gap: 8px;\r\n}\r\n\r\n.analysis-sql-preview {\r\n  font-family: var(--font-mono);\r\n  font-size: 12px;\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  color: #374151;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.analysis-snapshot-layout {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  gap: 12px;\r\n}\r\n\r\n.analysis-snapshot-list {\r\n  width: 140px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  overflow-y: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n}\r\n\r\n.analysis-snapshot-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 4px;\r\n  padding: 7px 10px;\r\n  border: none;\r\n  background: none;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  color: #374151;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n\r\n.analysis-snapshot-item:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.analysis-snapshot-item.active {\r\n  background: #dbeafe;\r\n  color: #1e40af;\r\n  font-weight: 600;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-snapshot-item { transition: none; }\r\n}\r\n\r\n.analysis-snapshot-detail {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.analysis-parallel-box {\r\n  background: #eff6ff;\r\n  border: 1px solid #bfdbfe;\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.analysis-parallel-box strong {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  color: #1e40af;\r\n}\r\n\r\n.analysis-plan-table-container {\r\n  flex: 1;\r\n  overflow: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n}\r\n\r\n.analysis-report-details {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.analysis-report-details summary {\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #374151;\r\n}\r\n\r\n.analysis-report-pre {\r\n  margin: 8px 0 0 0;\r\n  padding: 8px 10px;\r\n  /* 고정폭 유지 — 리포트 원문은 칸을 맞춘 표다. 11px·옅은 회색은 다크 모드에서 읽기 어려웠다(2026-11-02 신고) */\r\n  font-family: Consolas, 'D2Coding', 'Nanum Gothic Coding', 'Courier New', monospace;\r\n  font-size: 12px;\r\n  line-height: 1.45;\r\n  white-space: pre-wrap;\r\n  color: #1f2937;\r\n  background: #f9fafb;\r\n  border-radius: 6px;\r\n  max-height: 240px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* 수집 시작 시 백엔드 경고(진단/튜닝 팩 설정 등) */\r\n.analysis-warning {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border: 1px solid #fcd34d;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  font-size: 12px;\r\n  animation: analysis-fade-swap 160ms ease-out;\r\n}\r\n\r\n.analysis-warning ul {\r\n  margin: 0;\r\n  padding-left: 16px;\r\n}\r\n\r\n.analysis-warning li + li {\r\n  margin-top: 2px;\r\n}\r\n\r\n/* LiveSQL 백엔드 미도달 — 예시/수집 결과가 통째로 비는 사유 안내 */\r\n.analysis-backend-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 10px 20px 0;\r\n  padding: 9px 12px;\r\n  background: #fee2e2;\r\n  border: 1px solid #fca5a5;\r\n  border-radius: 6px;\r\n  color: #991b1b;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  animation: analysis-fade-swap 160ms ease-out;\r\n}\r\n\r\n.analysis-backend-error span {\r\n  flex: 1;\r\n}\r\n\r\n.analysis-backend-error button {\r\n  flex-shrink: 0;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 5px;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease;\r\n}\r\n\r\n.analysis-backend-error button:hover {\r\n  background: rgba(153, 27, 27, 0.12);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-backend-error { animation: none; }\r\n  .analysis-backend-error button { transition: none; }\r\n}\r\n\r\n/* 실측 통계 출처 안내 (값이 비어 보이는 이유 설명) */\r\n.analysis-stats-note {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  padding: 2px 2px 6px;\r\n}\r\n\r\n/* 실행 이력(AWR) 탭 툴바 */\r\n.analysis-history-sqlid {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.analysis-history-sqlid strong {\r\n  color: #374151;\r\n  margin-left: 4px;\r\n}\r\n\r\n.analysis-history-days {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-history-sqlid,\r\n[data-theme=\"dark\"] .analysis-history-days {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-history-sqlid strong {\r\n  color: var(--color-text);\r\n}\r\n\r\n/* 바인드 변수 표 */\r\n.analysis-binds-source {\r\n  margin-left: 8px;\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  font-family: var(--font-mono);\r\n  color: #9ca3af;\r\n}\r\n\r\n.analysis-binds-table {\r\n  margin-top: 8px;\r\n}\r\n\r\n.analysis-bind-value {\r\n  max-width: 320px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.analysis-bind-null {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-binds-source,\r\n[data-theme=\"dark\"] .analysis-bind-null {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n/* 조건절 정보 (Predicate Information) */\r\n.analysis-predicate-list {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-height: 180px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.analysis-predicate-item {\r\n  display: flex;\r\n  gap: 8px;\r\n  font-family: var(--font-mono);\r\n  font-size: 11px;\r\n}\r\n\r\n.analysis-predicate-id {\r\n  flex-shrink: 0;\r\n  min-width: 24px;\r\n  text-align: right;\r\n  color: #6b7280;\r\n  font-weight: 600;\r\n}\r\n\r\n.analysis-predicate-text {\r\n  white-space: pre-wrap;\r\n  word-break: break-all;\r\n  color: #4b5563;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-warning { animation: none; }\r\n}\r\n\r\n/* 다크 모드 */\r\n[data-theme=\"dark\"] .analysis-tabs {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-tab {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-tab:hover {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-tab.active {\r\n  color: var(--color-accent-fg);\r\n  border-bottom-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-toolbar-note {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-table-container,\r\n[data-theme=\"dark\"] .analysis-plan-table-container,\r\n[data-theme=\"dark\"] .analysis-snapshot-list,\r\n[data-theme=\"dark\"] .analysis-report-details {\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-table th {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text-muted);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-table td {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-row-demo {\r\n  background: rgba(253, 230, 138, 0.08);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-row-inline-panel td,\r\n[data-theme=\"dark\"] .analysis-sql-preview {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-interval-panel {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-snapshot-item {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-snapshot-item:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-snapshot-item.active {\r\n  background: rgba(59, 130, 246, 0.2);\r\n  color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-parallel-box {\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border-color: rgba(59, 130, 246, 0.3);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-report-details summary {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-report-pre {\r\n  /* --color-text-muted(#777) 는 어두운 바탕에서 흐렸다 — 본문 글자색보다 한 단계 밝게, 획도 조금 굵게 */\r\n  color: #e4e4e4;\r\n  background: var(--color-bg-secondary, #252526);\r\n  font-weight: 500;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n/* 라이트 팔레트 그대로면 다크에서 눈에 띄게 밝은 판이 된다 — 톤 다운한 대응색으로 교체 */\r\n[data-theme=\"dark\"] .analysis-error {\r\n  background: rgba(248, 113, 113, 0.12);\r\n  border: 1px solid rgba(248, 113, 113, 0.3);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-badge-demo {\r\n  background: rgba(251, 191, 36, 0.18);\r\n  color: #fbbf24;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-badge-parallel {\r\n  background: rgba(96, 165, 250, 0.18);\r\n  color: #93c5fd;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-backend-error {\r\n  background: rgba(248, 113, 113, 0.12);\r\n  border-color: rgba(248, 113, 113, 0.35);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-backend-error button:hover {\r\n  background: rgba(248, 113, 113, 0.18);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-warning {\r\n  background: rgba(251, 191, 36, 0.12);\r\n  border-color: rgba(251, 191, 36, 0.35);\r\n  color: #fbbf24;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-stats-note {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-predicate-id,\r\n[data-theme=\"dark\"] .analysis-predicate-text {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn-primary {\r\n  background: var(--color-accent);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-btn-primary:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* 실시간 성능에서 넘어온 조회 조건 표시 — 지금 보는 목록이 '전체'가 아님을 분명히 한다 */\r\n.analysis-filter-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border: 1px solid #bfdbfe;\r\n  border-radius: 999px;\r\n  background: #eff6ff;\r\n  color: #1e40af;\r\n  font-size: 11px;\r\n}\r\n.analysis-filter-chip code {\r\n  font-family: var(--font-mono);\r\n  background: rgba(255,255,255,0.7);\r\n  padding: 1px 5px;\r\n  border-radius: 3px;\r\n  max-width: 320px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.analysis-filter-chip .analysis-filter-window { opacity: 0.75; }\r\n.analysis-filter-chip button {\r\n  display: flex; align-items: center;\r\n  border: none; background: none; cursor: pointer;\r\n  color: #1e40af; padding: 0 0 0 2px;\r\n}\r\n.analysis-filter-chip button:hover { color: #1e3a8a; }\r\n\r\n[data-theme=\"dark\"] .analysis-filter-chip {\r\n  background: rgba(59,130,246,0.15);\r\n  border-color: rgba(59,130,246,0.4);\r\n  color: #93c5fd;\r\n}\r\n[data-theme=\"dark\"] .analysis-filter-chip code { background: rgba(0,0,0,0.3); }\r\n[data-theme=\"dark\"] .analysis-filter-chip button { color: #93c5fd; }\r\n\r\n/* 툴바 컨트롤 공통 높이 — dbmsperf 쪽과 같은 값.\r\n   두 모달이 '오라클 성능 분석' 한 창의 탭이라 높이가 갈리면 탭을 옮길 때 줄이 튄다. */\r\n.analysis-btn,\r\n.analysis-select {\r\n  height: 30px;\r\n  box-sizing: border-box;\r\n  padding: 0 14px;\r\n  font-size: 13px;\r\n}\r\n/* 아이콘과 글자를 같은 줄에 — 한글 글꼴은 줄 상자가 높아 글자가 아래로 앉아, 작은 아이콘이 위로 떠 보였다(2026-10-03).\r\n   줄 높이를 글자 크기로 좁히고 아이콘은 블록으로(기준선 여백 없이) 세운다 */\r\n.analysis-btn { line-height: 1; }\r\n.analysis-btn > svg { display: block; }\r\n.analysis-select { padding: 0 12px; }\r\n\r\n/* 마지막 새로고침 시각 — 툴바 오른쪽, \"쿼리보기\" 버튼 바로 앞 */\r\n.analysis-refreshed-at {\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  white-space: nowrap;\r\n}\r\n[data-theme=\"dark\"] .analysis-refreshed-at { color: var(--color-text-muted); }\r\n\r\n/* \"쿼리보기\" 팝오버 */\r\n.analysis-queryview-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1100;\r\n}\r\n.analysis-queryview-panel {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\r\n  width: 620px;\r\n  max-width: calc(92vw / var(--app-zoom, 1));\r\n  max-height: calc(80vh / var(--app-zoom, 1));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  animation: analysis-fade-swap 160ms ease-out;\r\n}\r\n@media (prefers-reduced-motion: reduce) { .analysis-queryview-panel { animation: none; } }\r\n.analysis-queryview-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 14px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n.analysis-queryview-body {\r\n  flex: 1;\r\n  overflow: auto;\r\n  margin: 0;\r\n  padding: 12px 14px;\r\n  font-family: var(--font-mono);\r\n  font-size: 12px;\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n  color: #1f2937;\r\n}\r\n.analysis-queryview-note {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 14px;\r\n  border-top: 1px solid #e5e7eb;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  background: #fafbfc;\r\n}\r\n[data-theme=\"dark\"] .analysis-queryview-panel { background: var(--color-bg-tertiary); }\r\n[data-theme=\"dark\"] .analysis-queryview-header { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .analysis-queryview-body { color: var(--color-text); }\r\n[data-theme=\"dark\"] .analysis-queryview-note { background: var(--color-bg-secondary); border-top-color: var(--color-border); color: var(--color-text-muted); }\r\n\r\n/* 실행 이력 — SQL_ID 직접 입력 */\r\n.analysis-sqlid-input {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  height: 30px;\r\n  padding: 0 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  color: #9ca3af;\r\n}\r\n.analysis-sqlid-input input {\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 12.5px;\r\n  color: #374151;\r\n  width: 140px;\r\n}\r\n[data-theme=\"dark\"] .analysis-sqlid-input { border-color: var(--color-input-border); }\r\n[data-theme=\"dark\"] .analysis-sqlid-input input { color: var(--color-text); }\r\n\r\n/* 최근 조회한 SQL_ID 리본(칩) */\r\n.analysis-recent-sqlids {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  padding: 4px 2px 8px;\r\n}\r\n.analysis-recent-label {\r\n  font-size: 10.5px;\r\n  font-weight: 700;\r\n  color: #9ca3af;\r\n  letter-spacing: 0.02em;\r\n  margin-right: 2px;\r\n}\r\n.analysis-recent-chip {\r\n  border: 1px solid #d1d5db;\r\n  background: #fff;\r\n  border-radius: 999px;\r\n  padding: 2px 10px;\r\n  font-size: 11px;\r\n  font-family: var(--font-mono);\r\n  color: #374151;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.analysis-recent-chip:hover { background: #f3f4f6; }\r\n.analysis-recent-chip.active { border-color: #3b82f6; background: rgba(59,130,246,0.1); color: #1d4ed8; }\r\n@media (prefers-reduced-motion: reduce) { .analysis-recent-chip { transition: none; } }\r\n[data-theme=\"dark\"] .analysis-recent-label { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .analysis-recent-chip { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .analysis-recent-chip:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .analysis-recent-chip.active { border-color: var(--color-accent-fg); background: rgba(59,130,246,0.18); color: #93c5fd; }\r\n\r\n/* 「문장 전체」 요약 줄 — GV$SQL_MONITOR 의 문장 한 행.\r\n   아래 plan line 그리드가 리포트와 맞는지 대조할 기준점이다(2026-09-21). */\r\n.analysis-stmt-total {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  padding: 6px 10px;\r\n  margin: 0 0 6px 0;\r\n  border: 1px solid var(--color-border, #e0e0e0);\r\n  border-radius: 4px;\r\n  background: var(--color-bg-secondary, #f8f9fa);\r\n  font-size: 11px;\r\n}\r\n.analysis-stmt-label {\r\n  font-weight: 600;\r\n  color: var(--color-text, #1f2937);\r\n}\r\n.analysis-stmt-item {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 4px;\r\n}\r\n.analysis-stmt-k { color: var(--color-text-muted, #9ca3af); }\r\n.analysis-stmt-v {\r\n  font-family: var(--font-mono);\r\n  color: var(--color-text, #1f2937);\r\n}\r\n.analysis-stmt-badge {\r\n  padding: 1px 7px;\r\n  border-radius: 9px;\r\n  background: var(--color-bg-tertiary, #eceef1);\r\n  color: var(--color-text-secondary, #4b5563);\r\n}\r\n/* 합계가 달라도 정상이라는 사실을 늘 옆에 둔다 — 없으면 또 \"왜 다르냐\"가 된다 */\r\n.analysis-stmt-note {\r\n  flex-basis: 100%;\r\n  font-size: 10px;\r\n  line-height: 1.5;\r\n  color: var(--color-text-muted, #9ca3af);\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-stmt-total {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .analysis-stmt-badge { background: var(--color-bg-secondary); }\r\n\r\n/* 칸의 성격을 알리는 표시 — 「DB Time 은 활성세션 기준」 같은 것 */\r\n.analysis-col-hint {\r\n  display: inline-block;\r\n  margin-left: 3px;\r\n  font-style: normal;\r\n  font-size: 9px;\r\n  opacity: 0.5;\r\n  cursor: help;\r\n}\r\n\r\n/* 옛 스냅샷·ASH 잘림 안내 — 값을 지우지 않고 그 사실을 말한다 */\r\n.analysis-legacy-note {\r\n  padding: 5px 9px;\r\n  margin: 0 0 6px 0;\r\n  border: 1px solid #fde68a;\r\n  border-left-width: 3px;\r\n  border-radius: 3px;\r\n  background: #fffbeb;\r\n  color: #92400e;\r\n  font-size: 11px;\r\n  line-height: 1.5;\r\n}\r\n[data-theme=\"dark\"] .analysis-legacy-note {\r\n  background: #3a2a00;\r\n  color: #ffc107;\r\n  border-color: #665500;\r\n}\r\n\r\n/* 중단 사유 배지 — 자동중단이 생긴 뒤로는 \"왜 멈췄나\" 가 곧바로 첫 질문이 된다.\r\n   사유 자체는 나쁜 소식이 아니므로(대개 '실행 완료') 경고색을 쓰지 않는다. */\r\n.analysis-stop-reason {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  border-radius: 10px;\r\n  font-size: 11px;\r\n  line-height: 18px;\r\n  background: #e5e7eb;\r\n  color: #4b5563;\r\n  border: 1px solid #d1d5db;\r\n  cursor: help;\r\n  white-space: nowrap;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-stop-reason {\r\n  background: var(--color-btn-bg);\r\n  color: var(--color-text-secondary, #9ca3af);\r\n  border-color: var(--color-btn-border);\r\n}\r\n\r\n/* ── 목록 조건 툴바 (S4) ─────────────────────────────────────────── */\r\n/* 기간·정렬은 좁아도 읽히므로 기본 min-width(160px)를 줄인다 — 한 줄에 다 들어가야\r\n   \"조건을 바꾸면 목록이 바뀐다\" 가 한눈에 보인다. */\r\n.analysis-toolbar .analysis-select-inline {\r\n  min-width: 120px;\r\n}\r\n\r\n.analysis-input-inline {\r\n  width: 180px;\r\n  padding: 5px 10px;\r\n  font-size: 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #111827;\r\n  transition: border-color 150ms ease, background 150ms ease;\r\n}\r\n\r\n.analysis-input-inline:focus {\r\n  outline: none;\r\n  border-color: #6366f1;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-input-inline {\r\n  background: var(--color-input-bg, var(--color-btn-bg));\r\n  color: var(--color-text);\r\n  border-color: var(--color-btn-border);\r\n}\r\n\r\n/* 실행 상태 칩 — \"판정 못 함\" 을 \"종료\" 와 다른 색으로 둔다.\r\n   모른다는 것과 끝났다는 것은 다른 말이고, 같은 색이면 사용자가 구분할 방법이 없다. */\r\n.analysis-state-chip {\r\n  display: inline-block;\r\n  padding: 1px 7px;\r\n  border-radius: 9px;\r\n  font-size: 11px;\r\n  line-height: 16px;\r\n  white-space: nowrap;\r\n  cursor: help;\r\n}\r\n\r\n.analysis-state-run    { background: #dcfce7; color: #15803d; border: 1px solid #86efac; }\r\n.analysis-state-done   { background: #f3f4f6; color: #6b7280; border: 1px solid #e5e7eb; }\r\n.analysis-state-unknown{ background: #fef3c7; color: #92400e; border: 1px solid #fde68a; }\r\n\r\n[data-theme=\"dark\"] .analysis-state-run    { background: #14532d; color: #bbf7d0; border-color: #166534; }\r\n[data-theme=\"dark\"] .analysis-state-done   { background: var(--color-btn-bg); color: var(--color-text-secondary, #9ca3af); border-color: var(--color-btn-border); }\r\n[data-theme=\"dark\"] .analysis-state-unknown{ background: #422006; color: #fde68a; border-color: #713f12; }\r\n\r\n/* 모듈 셀을 눌러 그 모듈만 본다 — 버튼이지만 표 안에서는 링크처럼 보여야 한다 */\r\n.analysis-link-cell {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  font: inherit;\r\n  color: #4f46e5;\r\n  cursor: pointer;\r\n  text-decoration: underline dotted;\r\n  transition: color 150ms ease;\r\n}\r\n\r\n.analysis-link-cell:hover { color: #3730a3; }\r\n\r\n[data-theme=\"dark\"] .analysis-link-cell { color: #a5b4fc; }\r\n[data-theme=\"dark\"] .analysis-link-cell:hover { color: #c7d2fe; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-input-inline,\r\n  .analysis-link-cell { transition: none; }\r\n}\r\n\r\n/* ── 실행 이력 2단 머리글 (S5) ───────────────────────────────────── */\r\n/* 무리를 색으로 갈라 둔다 — \"이 칸이 합계인가 실행당인가\" 를 매번 헤아리게 하면\r\n   2단 머리글을 둔 의미가 없다. */\r\n.analysis-group-head th {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  cursor: help;\r\n}\r\n\r\n.analysis-group-id     { background: #f9fafb; color: #6b7280; }\r\n.analysis-group-delta  { background: #eef2ff; color: #4338ca; }\r\n.analysis-group-perExec{ background: #ecfdf5; color: #047857; }\r\n\r\n[data-theme=\"dark\"] .analysis-group-head th { border-bottom-color: var(--color-btn-border); }\r\n[data-theme=\"dark\"] .analysis-group-id      { background: var(--color-btn-bg); color: var(--color-text-secondary, #9ca3af); }\r\n[data-theme=\"dark\"] .analysis-group-delta   { background: #1e1b4b; color: #c7d2fe; }\r\n[data-theme=\"dark\"] .analysis-group-perExec { background: #064e3b; color: #a7f3d0; }\r\n\r\n/* 「완료 0회」 배지 — 나쁜 소식이 아니라 **설명**이다(장시간 실행이 구간을 넘어갔다).\r\n   경고색을 쓰면 오류로 읽힌다. */\r\n.analysis-zeroexec-badge {\r\n  display: inline-block;\r\n  padding: 1px 6px;\r\n  border-radius: 9px;\r\n  font-size: 10px;\r\n  line-height: 15px;\r\n  white-space: nowrap;\r\n  background: #f3f4f6;\r\n  color: #6b7280;\r\n  border: 1px solid #e5e7eb;\r\n  cursor: help;\r\n}\r\n\r\n[data-theme=\"dark\"] .analysis-zeroexec-badge {\r\n  background: var(--color-btn-bg);\r\n  color: var(--color-text-secondary, #9ca3af);\r\n  border-color: var(--color-btn-border);\r\n}\r\n\r\n.analysis-history-chart {\r\n  margin-bottom: 10px;\r\n  animation: analysis-fade-swap 160ms ease-out;\r\n}\r\n\r\n.analysis-history-chart-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-history-chart { animation: none; }\r\n}\r\n\r\n/* ── 오브젝트별 읽기량 — 한 오브젝트를 한 줄에, 열마다 막대(2026-10-14) ───────────────── */\r\n.analysis-objreads { width: 100%; border-collapse: collapse; font-size: 12px; animation: analysis-fade-swap 160ms ease-out; }\r\n.analysis-objreads th { text-align: left; font-weight: 600; color: #6b7280; padding: 4px 8px; border-bottom: 1px solid #e5e7eb; white-space: nowrap; cursor: help; }\r\n.analysis-objreads th:first-child { cursor: default; }\r\n.analysis-objreads td { padding: 3px 8px; border-bottom: 1px solid #f3f4f6; }\r\n.analysis-objreads-name { max-width: 240px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-family: var(--font-mono, Consolas, monospace); }\r\n.analysis-objreads-cell { position: relative; display: flex; align-items: center; gap: 6px; min-width: 180px; height: 18px; }\r\n.analysis-objreads-bar { position: absolute; left: 0; top: 3px; bottom: 3px; border-radius: 2px; opacity: 0.28; }\r\n.analysis-objreads-bar.is-buffer { background: #3b82f6; }\r\n.analysis-objreads-bar.is-physical { background: #10b981; }\r\n.analysis-objreads-val { position: relative; margin-left: 4px; font-variant-numeric: tabular-nums; font-weight: 600; color: #374151; }\r\n.analysis-objreads-pct { position: relative; font-size: 11px; color: #6b7280; font-variant-numeric: tabular-nums; }\r\n[data-theme=\"dark\"] .analysis-objreads th { color: var(--color-text-secondary, #9ca3af); border-bottom-color: var(--color-border); }\r\n[data-theme=\"dark\"] .analysis-objreads td { border-bottom-color: var(--color-border); }\r\n[data-theme=\"dark\"] .analysis-objreads-val { color: var(--color-text); }\r\n[data-theme=\"dark\"] .analysis-objreads-bar { opacity: 0.4; }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-objreads { animation: none; }\r\n}\r\n\r\n/* 예시 데이터 체크 — 세션 분석·DBMS 성능과 같은 자리·모양(2026-10-03) */\r\n/* 오른쪽 여백은 DBMS 성능 탭의 같은 줄(.dbmsperf-embedded-bar)과 같게 — 창 가장자리에 붙지 않게 */\r\n.analysis-demo-bar { display: flex; justify-content: flex-end; align-items: center; padding: 6px 20px 0; flex-shrink: 0; }\r\n.analysis-demo-toggle { display: flex; align-items: center; gap: 4px; font-size: 12px; color: #6b7280; cursor: pointer; }\r\n[data-theme=\"dark\"] .analysis-demo-toggle { color: var(--color-text-muted); }\r\n\r\n/* 수집은 모니터링 권한의 것 — 권한이 없을 때 그 자리에서 말하는 줄(오류 배너가 아니다) */\r\n.analysis-empty-note { padding: 8px 12px; margin-bottom: 8px; border-radius: 4px; font-size: 12px; background: rgba(217, 119, 6, 0.12); border: 1px solid rgba(217, 119, 6, 0.3); }\r\n\r\n/* 실행 이력 — 최근 조회 칩마다 지우기(×) 단추(2026-10-14) */\r\n.analysis-recent-chip-removable { display: inline-flex; align-items: center; padding: 0; cursor: default; overflow: hidden; }\r\n.analysis-recent-chip-removable > button { all: unset; cursor: pointer; font: inherit; color: inherit; }\r\n.analysis-recent-chip-main { padding: 2px 4px 2px 10px; }\r\n.analysis-recent-chip-x { display: inline-flex; align-items: center; padding: 3px 7px 3px 3px; opacity: 0.55; transition: opacity 150ms ease, color 150ms ease; }\r\n.analysis-recent-chip-x:hover { opacity: 1; color: #dc2626; }\r\n.analysis-recent-chip-removable > button:focus-visible { outline: 2px solid #3b82f6; outline-offset: -2px; border-radius: 999px; }\r\n\r\n/* 실행 이력 — 그래프 종류(소요시간 / 블록 읽기) */\r\n.analysis-seg { display: inline-flex; border: 1px solid #d1d5db; border-radius: 6px; overflow: hidden; margin-right: 6px; }\r\n.analysis-seg > button { all: unset; cursor: pointer; padding: 3px 10px; font-size: 11px; color: #374151; transition: background-color 150ms ease, color 150ms ease; }\r\n.analysis-seg > button + button { border-left: 1px solid #d1d5db; }\r\n.analysis-seg > button:hover { background: #f3f4f6; }\r\n.analysis-seg > button.active { background: #2563eb; color: #fff; }\r\n.analysis-seg > button:focus-visible { outline: 2px solid #2563eb; outline-offset: -2px; }\r\n.analysis-chart-note { font-size: 11px; color: #6b7280; margin: 2px 0 4px; animation: analysis-fade-swap 160ms ease-out; }\r\n[data-theme=\"dark\"] .analysis-seg { border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .analysis-seg > button { color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .analysis-seg > button + button { border-left-color: var(--color-border); }\r\n[data-theme=\"dark\"] .analysis-seg > button:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .analysis-seg > button.active { background: #2563eb; color: #fff; }\r\n[data-theme=\"dark\"] .analysis-chart-note { color: var(--color-text-muted); }\r\n\r\n/* 상세 목록 — 고른 그래프와 관련된 컬럼을 칠한다 */\r\n.analysis-history-details > summary { cursor: pointer; }\r\n.analysis-table th.is-related { color: #1d4ed8; background: #eff6ff; }\r\n.analysis-table td.is-related { background: rgba(37, 99, 235, 0.06); }\r\n[data-theme=\"dark\"] .analysis-table th.is-related { color: #93c5fd; background: rgba(59, 130, 246, 0.16); }\r\n[data-theme=\"dark\"] .analysis-table td.is-related { background: rgba(147, 197, 253, 0.08); }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .analysis-seg > button, .analysis-recent-chip-x { transition: none; }\r\n  .analysis-chart-note { animation: none; }\r\n}\r\n\r\n.analysis-table td.analysis-nowrap { white-space: nowrap; }\r\n\r\n/* 실행 이력 — 노드마다 한 장(RAC) */\r\n.analysis-history-inst + .analysis-history-inst { margin-top: 4px; border-top: 1px dashed #e5e7eb; padding-top: 2px; }\r\n.analysis-history-inst-label { font-size: 11px; font-weight: 600; color: #4b5563; margin: 2px 0 0 4px; }\r\n[data-theme=\"dark\"] .analysis-history-inst-label { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .analysis-history-inst + .analysis-history-inst { border-top-color: var(--color-border); }\r\n\r\n/* 실행 이력 — SQL 텍스트로 찾은 후보(2026-10-22) */\r\n.analysis-sqlsearch { margin: 6px 0; border: 1px solid var(--color-border, #e5e7eb); border-radius: 6px; animation: analysis-sqlsearch-in 160ms ease-out; }\r\n@keyframes analysis-sqlsearch-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\r\n.analysis-sqlsearch-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 6px 8px; font-size: 12px; }\r\n.analysis-sqlsearch-list { max-height: 240px; overflow: auto; border-top: 1px solid var(--color-border, #e5e7eb); }\r\n.analysis-sqlsearch-row { cursor: pointer; transition: background-color 150ms ease; }\r\n.analysis-sqlsearch-row:hover { background: rgba(37, 99, 235, 0.08); }\r\n.analysis-sqlsearch-row.active { background: rgba(37, 99, 235, 0.16); }\r\n.analysis-sqlsearch-text { max-width: 640px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n@media (prefers-reduced-motion: reduce) { .analysis-sqlsearch { animation: none; } .analysis-sqlsearch-row { transition: none; } }\r\n\r\n/* ── 실행 중인 쿼리 · 페치 대기 · 작은 아이콘 단추 (2026-10-27) ── */\r\n.analysis-state-fetch  { background: #e0f2fe; color: #075985; border: 1px solid #7dd3fc; }\r\n[data-theme=\"dark\"] .analysis-state-fetch { background: #0c4a6e; color: #bae6fd; border-color: #075985; }\r\n.analysis-badge-fetch {\r\n  display: inline-block; margin-left: 6px; padding: 1px 6px; border-radius: 4px;\r\n  background: #e0f2fe; color: #075985; font-size: 10px; font-weight: 600;\r\n}\r\n[data-theme=\"dark\"] .analysis-badge-fetch { background: #0c4a6e; color: #bae6fd; }\r\n.analysis-row-actions .analysis-icon-btn { vertical-align: middle; }\r\n.analysis-row-actions .analysis-icon-btn + .analysis-icon-btn { margin-left: 3px; }\r\n.analysis-icon-btn {\r\n  display: inline-flex; align-items: center; justify-content: center;\r\n  width: 24px; height: 22px; padding: 0; border: 1px solid #d1d5db; border-radius: 4px;\r\n  background: #fff; color: #4b5563; cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\r\n}\r\n.analysis-icon-btn:hover:not(:disabled) { background: #f3f4f6; color: #111827; border-color: #9ca3af; }\r\n.analysis-icon-btn.is-primary { color: #2563eb; border-color: #93c5fd; }\r\n.analysis-icon-btn.is-primary:hover:not(:disabled), .analysis-icon-btn.on { background: #eff6ff; color: #1d4ed8; }\r\n.analysis-icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }\r\n[data-theme=\"dark\"] .analysis-icon-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .analysis-icon-btn:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }\r\n[data-theme=\"dark\"] .analysis-icon-btn.is-primary { color: #93c5fd; }\r\n.analysis-collect-error { margin: 6px; font-size: 11px; word-break: break-all; }\r\n@media (prefers-reduced-motion: reduce) { .analysis-icon-btn { transition: none; } }\r\n\n/* ── 실행 중인 쿼리 — 표 본문만 스크롤(2026-11-03 시험 피드백) ─────────────────\n   도구 줄·리본·표 머리는 서 있고 표 칸(analysis-table-container)만 스크롤된다. 머리(th)는 원래 sticky 다 */\n.analysis-active-pane {\n  flex: 1 1 auto;\n  min-height: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.analysis-active-pane > .analysis-toolbar,\n.analysis-active-pane > .analysis-ribbon,\n.analysis-active-pane > .analysis-error { flex-shrink: 0; }\n.analysis-active-pane > .analysis-table-container { flex: 1 1 auto; min-height: 0; }\n.analysis-modal-body:has(> .analysis-active-pane) { overflow: hidden; }\n\n/* 리본 — 노드 고르기 · 실행 상태 거르기 */\n.analysis-ribbon {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n.analysis-ribbon-chip {\n  padding: 2px 9px;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #fff;\n  color: #374151;\n  font-size: 11.5px;\n  cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.analysis-ribbon-chip:hover { background: #f3f4f6; }\n.analysis-ribbon-chip.on { background: #dbeafe; border-color: #60a5fa; color: #1d4ed8; font-weight: 600; }\n.analysis-ribbon-count { font-variant-numeric: tabular-nums; opacity: 0.75; margin-left: 2px; }\n.analysis-state-chip-run.on { background: #dcfce7; border-color: #86efac; color: #15803d; }\n.analysis-state-chip-fetch.on { background: #e0f2fe; border-color: #7dd3fc; color: #075985; }\n[data-theme=\"dark\"] .analysis-ribbon-chip { background: var(--color-btn-bg, #374151); border-color: var(--color-border, #4b5563); color: var(--color-text, #e5e7eb); }\n[data-theme=\"dark\"] .analysis-ribbon-chip:hover { background: var(--color-hover, #4b5563); }\n[data-theme=\"dark\"] .analysis-ribbon-chip.on { background: #1e3a8a; border-color: #1d4ed8; color: #dbeafe; }\n[data-theme=\"dark\"] .analysis-state-chip-run.on { background: #14532d; border-color: #166534; color: #bbf7d0; }\n[data-theme=\"dark\"] .analysis-state-chip-fetch.on { background: #0c4a6e; border-color: #075985; color: #bae6fd; }\n\n/* SQL 칸 — 누르면 전문 창 */\n.analysis-sql-cell.is-clickable { cursor: pointer; }\n.analysis-sql-cell.is-clickable:hover { text-decoration: underline dotted; }\n\n@media (prefers-reduced-motion: reduce) {\n  .analysis-ribbon-chip { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
